import React, { Component, PropTypes } from 'react';
import {Link} from 'react-router';
import '../styles/question.scss';
import RecommendationAlgorithm from '../models/RecommendationAlgorithm'
import CitationComponent from './CitationComponent'
import Question from '../models/Question'
import Answer from '../models/Answer'
import NumPad from './NumPad'
var ReactCSSTransitionGroup = require('react-addons-css-transition-group');
import * as constants from '../constants/constants'
import Persistence from '../Persistence/Persistence'
import NewLineHelper from '../utils/newLineHelper'
import StringHelper from '../utils/stringHelper'
import TextParser from '../models/TextParser'
import NavBar from './NavBar'

class QuestionComponentDelegate {
  constructor() {

  }

  didSelectMultipleChoiceAnswer(question, answer) {

  }
  didSelectedInputAnswer(questionComponent, inputAnswer, selectedValue) {

  }
}

class QuestionComponent extends Component {
  constructor() {
    super();
    this.inputText = null;
    this.state = {shownCitation: null, inputValue: null, unitsButtonText: null};
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  componentWillMount() {
    if (this.question().inputAnswer != null) {
      this.updateInputText();
      if (this.showsUnitsButton()) {
        this.updateUnits();
      }
    }
  }
  componentDidMount() {
    if (this.isInputQuestion()) {
      document.addEventListener("keydown", this.handleKeyPress);
    }
  }

  componentWillUnmount() {
    if (this.isInputQuestion()) {
      document.removeEventListener("keydown", this.handleKeyPress);
    }
  }

  question() {
    return this.props.question;
  }

  delegate() {
    return this.props.delegate;
  }

  handleKeyPress(event) {
    let key = String.fromCharCode(event.which);
    if (['1','2','3','4','5','6','7','8','9','0'].indexOf(key) > -1) {
      this.didEnterText(null, key);
    }
    if (event.keyCode == 13) {
      this.numPadNextButtonClick(event);
    }
  }

  handleReferenceClicked(citation, event) {
    this.setState({shownCitation: citation});
  }

  handleClick(index, event) {
    // this.setState({showCitation: !this.state.showCitation});
    let answer = this.question().multipleChoiceAnswers[index];
    this.delegate().didSelectMultipleChoiceAnswer(this, answer);
  }

  numPadNextButtonClick(event) {
    if (!this.validateInput()) {
      return;
    }
    var selectedInputValue = this.selectedInputValue();
    let usesSIUnits = Persistence.usesSIUnits();
    let sameUnits = this.question().inputAnswer.unitsSI == this.question().inputAnswer.unitsUS;
    if (!sameUnits && usesSIUnits && this.question().inputAnswer.maxValue && this.question().inputAnswer.minValue) {
      selectedInputValue = selectedInputValue*constants.kmmollTOmgdl;
    }
    this.delegate().didSelectedInputAnswer(this, this.question().inputAnswer, selectedInputValue);
  }

  unitsButtonClicked() {
    var usesSIUnits = Persistence.usesSIUnits();
    Persistence.setUsesSIUnits(!Persistence.usesSIUnits());
    this.updateUnits();
    this.updateInputText();
  }

  citationComponentDidCancel(citationComponent) {
    this.setState({shownCitation: null});
  }

  validateInput() {
    let valid = true;
    var message = null;
    let selectedInputValue = this.selectedInputValue();
    let usesSIUnits = Persistence.usesSIUnits();
    var minValue = this.question().inputAnswer.minValue;
    var maxValue = this.question().inputAnswer.maxValue;
    let sameUnits = this.question().inputAnswer.unitsSI == this.question().inputAnswer.unitsUS;
      if (!sameUnits && maxValue != null && minValue != null && usesSIUnits) {
        minValue = minValue/constants.kmmollTOmgdl;
        maxValue = maxValue/constants.kmmollTOmgdl;
      }
      if (selectedInputValue == null) {
        valid = false;
      }
      else if (minValue != null && minValue > selectedInputValue) {
        valid = false;
      }
      else if (maxValue != null && maxValue < selectedInputValue) {
        valid = false;
      }
      if (!valid) {
        if (minValue != null && maxValue != null) {
          message = "Please select a value between " + minValue + " and " + maxValue;
        }
        else if (!selectedInputValue) {
          message = "Please select a value";
        }
        alert(message);
      }
      return valid;
    }

  selectedInputValue() {
    let inputValue = this.inputText;
    if (inputValue == null || inputValue.length < 1) {
      return null;
    }
    return parseFloat(inputValue);
  }

  didEnterText(numPad, text) {
    if (this.inputText == null) {
      this.inputText = text;
    }
    else {
      this.inputText += text;
    }
    this.updateInputText();
  }

  updateInputText() {
    var text = "";
    if (this.inputText != null) {
      text += this.inputText;
    }
    var units = this.question().inputAnswer.unitsUS;
    if (Persistence.usesSIUnits()) {
      units = this.question().inputAnswer.unitsSI;
    }
    if (units != null) {
      text += " " + units;
    }
    this.setState({inputValue: text});
  }

  clearButtonTouched(numPad) {
    this.inputText = "";
    this.updateInputText();
  }

  isInputQuestion() {
    return this.question() != null && this.question().inputAnswer != null;
  }

  showsUnitsButton() {
    let question = this.question();
    return question.inputAnswer.unitsSI && question.inputAnswer.unitsUS && question.inputAnswer.unitsUS != question.inputAnswer.unitsSI;
  }

  updateUnits() {
    let usesSIUnits = Persistence.usesSIUnits();
    let alternateUnits = usesSIUnits ? this.question().inputAnswer.unitsUS : this.question().inputAnswer.unitsSI;
    this.setState({unitsButtonText: "Change to " + alternateUnits});
  }


  renderButtons(multipleChoiceAnswers) {
    if (multipleChoiceAnswers.length > 0) {
      return multipleChoiceAnswers.map((answer, index) => (
        <div className={"button"} key={index} onClick={this.handleClick.bind(this, index)}>{answer.answerText}</div>
      ));
    }
    return [];
  }

  renderButtonsAndContainer() {
    return (
      <div className={"buttonContainer" + ((this.question().multipleChoiceAnswers != null && this.question().multipleChoiceAnswers.length > 3) ? " multipleRow" : "")}>
        {this.renderButtons(this.question().multipleChoiceAnswers)}
        </div>
    );
  }

  renderNumPad() {
    return (
      <div className="numPadContainer">
        <NumPad delegate={this}/>
        <div className="numPadNextButton" onClick={this.numPadNextButtonClick.bind(this)}>Next</div>
      </div>
    );
  }

  renderAppropriateInput() {
    if (this.question().multipleChoiceAnswers != null) {
      return this.renderButtonsAndContainer();
    }
    else if (this.question().inputAnswer != null) {
      return this.renderNumPad();
    }
    return null;
  }

  renderInputValue() {
  return  (
    <div className="inputTextContainer">
      <div className="inputText">
        {this.state.inputValue}
      </div>
      </div>
      );
  }

  renderChangeUnitsButton() {
    return (
      <div className="changeUnitsContainer">
        <div className="changeUnitsText" onClick={this.unitsButtonClicked.bind(this)}>{this.state.unitsButtonText}</div>
      </div>
    )
  }

  questionDisplayText() {
    let blocks = TextParser.TextBlocksFromText(this.question().questionText);
    let divs = [];
    for (var i=0;i<blocks.length;i++) {
      let block = blocks[i];
      var d = null;
      if (block.citation != null) {
        d = <span className="reference" key={i} onClick={this.handleReferenceClicked.bind(this, block.citation)}>{block.citation.linkText()}</span>
      }
      else {
        d = <span key={i}>{block.text}</span>
      }
      divs.push(d);
    }
    return divs;
  }

  shouldHorizontallyCenterText() {
    let algorithm = this.props.navigation.algorithm;
    if (this.question().inputAnswer != null ||
      this.question().questionText.length < 70) {
      return true;
    }
    return false;
  }

  render() {
    return (
      <div className={"root"}>
        <div className="contentContainer">
          {this.props.navigation.navBar()}
          <div className={"topContainer"}>
            <div className={"questionText" + (this.shouldHorizontallyCenterText() ? " questionTextCenter" : "")}>
              <div className="textTopGradient"/>
              {this.question().isIntroQuestion ? <img src={require("../images/aspiringuide-logo.png")} className="questionAspirinLogo" /> : null}
              <div>{this.questionDisplayText()}</div>
              {this.isInputQuestion() ? this.renderInputValue() : null}
              {this.isInputQuestion() && this.showsUnitsButton() ? this.renderChangeUnitsButton() : null}
            </div>
          </div>
          {this.renderAppropriateInput()}
        </div>

        <ReactCSSTransitionGroup transitionName="citation" transitionEnterTimeout={300} transitionLeaveTimeout={300}>
        {this.state.shownCitation != null ? <CitationComponent citation={this.state.shownCitation} delegate={this}/> : null}
          </ReactCSSTransitionGroup>
      </div>

    );
  }

}

QuestionComponent.propTypes = {
  question: Question,
  // delegate: QuestionComponentDelegate,
};

export default QuestionComponent;



/** WEBPACK FOOTER **
 ** ./src/components/QuestionComponent.js
 **/